var items = {
  "block.minecraft.air": "ריווא",
  "block.minecraft.stone": "ןבא",
  "block.minecraft.granite": "טינרג",
  "block.minecraft.polished_granite": "שטולמ טינרג",
  "block.minecraft.diorite": "טירויד",
  "block.minecraft.polished_diorite": "שטולמ טירויד",
  "block.minecraft.andesite": "טיזדנא",
  "block.minecraft.polished_andesite": "שטולמ טיזדנא",
  "block.minecraft.grass_block": "אשד קולב",
  "block.minecraft.dirt": "רפע",
  "block.minecraft.coarse_dirt": "סג רפע",
  "block.minecraft.podzol": "לוזדופ",
  "block.minecraft.crimson_nylium": "ןמגרא םויליינ",
  "block.minecraft.warped_nylium": "תוועמ םויליינ",
  "block.minecraft.cobblestone": "תקסורמ ןבא",
  "block.minecraft.oak_planks": "ןולא ץע ישרק",
  "block.minecraft.spruce_planks": "תיחושא ץע ישרק",
  "block.minecraft.birch_planks": "רדש ץע ישרק",
  "block.minecraft.jungle_planks": "לגנו'ג ץע ישרק",
  "block.minecraft.acacia_planks": "הטיש ץע ישרק",
  "block.minecraft.dark_oak_planks": "ההכ ןולא ץע ישרק",
  "block.minecraft.crimson_planks": "ןמגרא ץע ישרק",
  "block.minecraft.warped_planks": "םיתוועמ םישרק",
  "block.minecraft.oak_sapling": "ןולא ליתש",
  "block.minecraft.spruce_sapling": "תיחושא ליתש",
  "block.minecraft.birch_sapling": "רדש ליתש",
  "block.minecraft.jungle_sapling": "לגנו'ג ליתש",
  "block.minecraft.acacia_sapling": "הטיש ליתש",
  "block.minecraft.dark_oak_sapling": "ההכ ןולא ליתש",
  "block.minecraft.bedrock": "דוסי ןבא",
  "block.minecraft.sand": "לוח",
  "block.minecraft.red_sand": "םודא לוח",
  "block.minecraft.gravel": "ץצח",
  "block.minecraft.gold_ore": "בהז תרפע",
  "block.minecraft.iron_ore": "לזרב תרפע",
  "block.minecraft.coal_ore": "םחפ תרפע",
  "block.minecraft.nether_gold_ore": "ר'תנ בהז תרפע",
  "block.minecraft.oak_log": "ןולא ץע",
  "block.minecraft.spruce_log": "תיחושא ץע",
  "block.minecraft.birch_log": "רדש ץע",
  "block.minecraft.jungle_log": "לגנו'ג ץע",
  "block.minecraft.acacia_log": "הטיש ץע",
  "block.minecraft.dark_oak_log": "ההכ ןולא ץע",
  "block.minecraft.crimson_stem": "ןמגרא ץע עזג",
  "block.minecraft.warped_stem": "תוועמ עזג",
  "block.minecraft.stripped_oak_log": "ףיושמ ןולא ץע",
  "block.minecraft.stripped_spruce_log": "ףיושמ תיחושא ץע",
  "block.minecraft.stripped_birch_log": "ףיושמ רדש ץע",
  "block.minecraft.stripped_jungle_log": "ףיושמ לגנו'ג ץע",
  "block.minecraft.stripped_acacia_log": "ףיושמ הטיש ץע",
  "block.minecraft.stripped_dark_oak_log": "ףיושמ ההכ ןולא ץע",
  "block.minecraft.stripped_crimson_stem": "ףיושמ ןמגרא ץע עזג",
  "block.minecraft.stripped_warped_stem": "ףיושמ תוועמ עזג",
  "block.minecraft.stripped_oak_wood": "ףיושמ ןולא ץע",
  "block.minecraft.stripped_spruce_wood": "ףיושמ תיחושא ץע",
  "block.minecraft.stripped_birch_wood": "ףיושמ רדש ץע",
  "block.minecraft.stripped_jungle_wood": "ףיושמ לגנו'ג ץע",
  "block.minecraft.stripped_acacia_wood": "ףיושמ הטיש ץע",
  "block.minecraft.stripped_dark_oak_wood": "ףיושמ ההכ ןולא ץע",
  "block.minecraft.stripped_crimson_hyphae": "םיפייושמ ןמגרא ילידג",
  "block.minecraft.stripped_warped_hyphae": "םיפייושמ םיתוועמ םילידג",
  "block.minecraft.oak_wood": "ןולא ץע",
  "block.minecraft.spruce_wood": "תיחושא ץע",
  "block.minecraft.birch_wood": "רדש ץע",
  "block.minecraft.jungle_wood": "לגנו'ג ץע",
  "block.minecraft.acacia_wood": "הטיש ץע",
  "block.minecraft.dark_oak_wood": "ההכ ןולא ץע",
  "block.minecraft.crimson_hyphae": "ןמגרא ילידג",
  "block.minecraft.warped_hyphae": "םיתוועמ םילידג",
  "block.minecraft.oak_leaves": "ןולא ילע",
  "block.minecraft.spruce_leaves": "תיחושא ילע",
  "block.minecraft.birch_leaves": "רדש ילע",
  "block.minecraft.jungle_leaves": "לגנו'ג ילע",
  "block.minecraft.acacia_leaves": "הטיש ילע",
  "block.minecraft.dark_oak_leaves": "ההכ ןולא ילע",
  "block.minecraft.sponge": "גופס",
  "block.minecraft.wet_sponge": "בוטר גופס",
  "block.minecraft.glass": "תיכוכז",
  "block.minecraft.lapis_ore": "ילוזאל סיפאל תרפע",
  "block.minecraft.lapis_block": "ילוזאל סיפאל קולב",
  "block.minecraft.dispenser": "ןקרוז",
  "block.minecraft.sandstone": "לוח ןבא",
  "block.minecraft.chiseled_sandstone": "תלסופמ לוח ןבא",
  "block.minecraft.cut_sandstone": "הכותח לוח ןבא",
  "block.minecraft.note_block": "לילצ קולב",
  "block.minecraft.powered_rail": "תענוממ הליסמ",
  "block.minecraft.detector_rail": "ןשייח תליסמ",
  "block.minecraft.sticky_piston": "הקיבד הנכוב",
  "block.minecraft.cobweb": "שיבכע ירוק",
  "block.minecraft.grass": "אשד",
  "block.minecraft.fern": "ךרש",
  "block.minecraft.dead_bush": "תמ חיש",
  "block.minecraft.seagrass": "םי בשע",
  "block.minecraft.sea_pickle": "םי ןופפלמ",
  "block.minecraft.piston": "הנכוב",
  "block.minecraft.white_wool": "ןבל רמצ",
  "block.minecraft.orange_wool": "םותכ רמצ",
  "block.minecraft.magenta_wool": "הטנ'גמ רמצ",
  "block.minecraft.light_blue_wool": "תלכת רמצ",
  "block.minecraft.yellow_wool": "בוהצ רמצ",
  "block.minecraft.lime_wool": "םייל רמצ",
  "block.minecraft.pink_wool": "דורו רמצ",
  "block.minecraft.gray_wool": "רופא רמצ",
  "block.minecraft.light_gray_wool": "ריהב רופא רמצ",
  "block.minecraft.cyan_wool": "ןאיצ רמצ",
  "block.minecraft.purple_wool": "לוגס רמצ",
  "block.minecraft.blue_wool": "לוחכ רמצ",
  "block.minecraft.brown_wool": "םוח רמצ",
  "block.minecraft.green_wool": "קורי רמצ",
  "block.minecraft.red_wool": "םודא רמצ",
  "block.minecraft.black_wool": "רוחש רמצ",
  "block.minecraft.dandelion": "יראה ןש",
  "block.minecraft.poppy": "גרפ",
  "block.minecraft.blue_orchid": "לוחכ בלחס",
  "block.minecraft.allium": "םוש",
  "block.minecraft.azure_bluet": "לוחכ רב חרפ",
  "block.minecraft.red_tulip": "םודא ינועבצ",
  "block.minecraft.orange_tulip": "םותכ ינועבצ",
  "block.minecraft.white_tulip": "ןבל ינועבצ",
  "block.minecraft.pink_tulip": "דורו ינועבצ",
  "block.minecraft.oxeye_daisy": "הנבל תיצרח",
  "block.minecraft.cornflower": "לוחכ רדרד",
  "block.minecraft.lily_of_the_valley": "םיקמעה תנשוש",
  "block.minecraft.wither_rose": "ר'תיוו דרו",
  "block.minecraft.brown_mushroom": "המוח הירטפ",
  "block.minecraft.red_mushroom": "המודא היירטפ",
  "block.minecraft.crimson_fungus": "ןמגרא תיירטפ",
  "block.minecraft.warped_fungus": "תתוועמ היירטפ",
  "block.minecraft.crimson_roots": "ןמגרא ישרוש",
  "block.minecraft.warped_roots": "םיתוועמ םישרוש",
  "block.minecraft.nether_sprouts": "ר'תנ יטבנ",
  "block.minecraft.weeping_vines": "יכב ינפג",
  "block.minecraft.twisting_vines": "תולתפתמ םינפג",
  "block.minecraft.sugar_cane": "רכוס הנק",
  "block.minecraft.kelp": "הצא",
  "block.minecraft.bamboo": "קובמב",
  "block.minecraft.gold_block": "בהז קולב",
  "block.minecraft.iron_block": "לזרב קולב",
  "block.minecraft.oak_slab": "יוצח ןולא שרק",
  "block.minecraft.spruce_slab": "יוצח תיחושא שרק",
  "block.minecraft.birch_slab": "יוצח רדש שרק",
  "block.minecraft.jungle_slab": "יוצח לגנו'ג ץע שרק",
  "block.minecraft.acacia_slab": "יוצח הטיש שרק",
  "block.minecraft.dark_oak_slab": "יוצח ההכ ןולא שרק",
  "block.minecraft.crimson_slab": "יוצח ןמגרא ץע שרק",
  "block.minecraft.warped_slab": "יוצח תוועמ שרק",
  "block.minecraft.stone_slab": "היוצח ןבא",
  "block.minecraft.smooth_stone_slab": "היוצח הקלח ןבא",
  "block.minecraft.sandstone_slab": "היוצח לוח ןבא",
  "block.minecraft.cut_sandstone_slab": "היוצח הכותח לוח ןבא",
  "block.minecraft.petrified_oak_slab": "יוצח ןבואמ ןולא",
  "block.minecraft.cobblestone_slab": "היוצח תקסורמ ןבא",
  "block.minecraft.brick_slab": "היוצח הנבל",
  "block.minecraft.stone_brick_slab": "תויוצח ןבא ינבל",
  "block.minecraft.nether_brick_slab": "היוצח ר'תנ תנבל",
  "block.minecraft.quartz_slab": "יוצח ץרווק",
  "block.minecraft.red_sandstone_slab": "היוצח המודא לוח ןבא",
  "block.minecraft.cut_red_sandstone_slab": "היוצח הכותח המודא לוח ןבא",
  "block.minecraft.purpur_slab": "יוצח רופרופ",
  "block.minecraft.prismarine_slab": "יוצח ןירמזירפ",
  "block.minecraft.prismarine_brick_slab": "היוצח ןירמזירפ תנבל",
  "block.minecraft.dark_prismarine_slab": "יוצח ההכ ןירמזירפ",
  "block.minecraft.smooth_quartz": "קלח ץרווק קולב",
  "block.minecraft.smooth_red_sandstone": "הקלח המודא לוח ןבא",
  "block.minecraft.smooth_sandstone": "הקלח לוח ןבא",
  "block.minecraft.smooth_stone": "הקלח ןבא",
  "block.minecraft.bricks": "םינבל",
  "block.minecraft.tnt": "ץפנ רמוח",
  "block.minecraft.bookshelf": "םירפס ףדמ",
  "block.minecraft.mossy_cobblestone": "תקסורמ בחט ןבא",
  "block.minecraft.obsidian": "ןאידיסבוא",
  "block.minecraft.torch": "דיפל",
  "block.minecraft.end_rod": "דנא טומ",
  "block.minecraft.chorus_plant": "סורוק חמצ",
  "block.minecraft.chorus_flower": "סורוק חרפ",
  "block.minecraft.purpur_block": "רופרופ קולב",
  "block.minecraft.purpur_pillar": "רופרופ דומע",
  "block.minecraft.purpur_stairs": "רופרופ תוגרדמ",
  "block.minecraft.spawner": "ןמזמ",
  "block.minecraft.oak_stairs": "ןולא תוגרדמ",
  "block.minecraft.chest": "הבית",
  "block.minecraft.diamond_ore": "םולהי תרפע",
  "block.minecraft.diamond_block": "םולהי קולב",
  "block.minecraft.crafting_table": "הכאלמ ןחלוש",
  "block.minecraft.farmland": "הגורע",
  "block.minecraft.furnace": "רונת",
  "block.minecraft.ladder": "םלוס",
  "block.minecraft.rail": "הליסמ",
  "block.minecraft.cobblestone_stairs": "תקסורמ ןבא תוגרדמ",
  "block.minecraft.lever": "קספמ",
  "block.minecraft.stone_pressure_plate": "ןבאמ ץחל תיחול",
  "block.minecraft.oak_pressure_plate": "ןולאמ ץחל תיחול",
  "block.minecraft.spruce_pressure_plate": "תיחושאמ ץחל תיחול",
  "block.minecraft.birch_pressure_plate": "רדשמ ץחל תיחול",
  "block.minecraft.jungle_pressure_plate": "לגנו'ג ץעמ ץחל תיחול",
  "block.minecraft.acacia_pressure_plate": "הטישמ ץחל תיחול",
  "block.minecraft.dark_oak_pressure_plate": "ההכ ןולאמ ץחל תיחול",
  "block.minecraft.crimson_pressure_plate": "ןמגרא ץעמ ץחל תיחול",
  "block.minecraft.warped_pressure_plate": "תתוועמ ץחל תיחול",
  "block.minecraft.polished_blackstone_pressure_plate": "תשטולמ הרוחש ןבאמ ץחל תיחול",
  "block.minecraft.redstone_ore": "ןוטסדר תרפע",
  "block.minecraft.redstone_torch": "ןוטסדר דיפל",
  "block.minecraft.snow": "גלש",
  "block.minecraft.ice": "חרק",
  "block.minecraft.snow_block": "גלש קולב",
  "block.minecraft.cactus": "סוטקק",
  "block.minecraft.clay": "רמיח",
  "block.minecraft.jukebox": "הניגנ תבית",
  "block.minecraft.oak_fence": "ןולא רדג",
  "block.minecraft.spruce_fence": "תיחושא רדג",
  "block.minecraft.birch_fence": "רדש רדג",
  "block.minecraft.jungle_fence": "לגנו'ג ץע רדג",
  "block.minecraft.acacia_fence": "הטיש רדג",
  "block.minecraft.dark_oak_fence": "ההכ ןולא רדג",
  "block.minecraft.crimson_fence": "ןמגרא ץע רדג",
  "block.minecraft.warped_fence": "תתוועמ רדג",
  "block.minecraft.pumpkin": "תעלד",
  "block.minecraft.carved_pumpkin": "תפלוגמ תעלד",
  "block.minecraft.netherrack": "קארר'תנ",
  "block.minecraft.soul_sand": "המשנ לוח",
  "block.minecraft.soul_soil": "המשנ רפע",
  "block.minecraft.basalt": "תלזב",
  "block.minecraft.polished_basalt": "תשטולמ תלזב",
  "block.minecraft.soul_torch": "המשנ דיפל",
  "block.minecraft.glowstone": "ןוטסולג",
  "block.minecraft.jack_o_lantern": "תעלד תרונמ",
  "block.minecraft.oak_trapdoor": "ןולאמ םירתס תלד",
  "block.minecraft.spruce_trapdoor": "תיחושאמ םירתס תלד",
  "block.minecraft.birch_trapdoor": "רדשמ םירתס תלד",
  "block.minecraft.jungle_trapdoor": "לגנו'ג ץעמ םירתס תלד",
  "block.minecraft.acacia_trapdoor": "הטישמ םירתס תלד",
  "block.minecraft.dark_oak_trapdoor": "ההכ ןולאמ םירתס תלד",
  "block.minecraft.crimson_trapdoor": "ןמגרא ץעמ םירתס תלד",
  "block.minecraft.warped_trapdoor": "תתוועמ םירתס תלד",
  "block.minecraft.infested_stone": "העוגנ ןבא",
  "block.minecraft.infested_cobblestone": "העוגנ תקסורמ ןבא",
  "block.minecraft.infested_stone_bricks": "תועוגנ ןבא ינבל",
  "block.minecraft.infested_mossy_stone_bricks": "תועוגנ בחט ןבא ינבל",
  "block.minecraft.infested_cracked_stone_bricks": "תועוגנ תוקודס ןבא ינבל",
  "block.minecraft.infested_chiseled_stone_bricks": "תועוגנ תושטולמ ןבא ינבל",
  "block.minecraft.stone_bricks": "ןבא ינבל",
  "block.minecraft.mossy_stone_bricks": "בחט ןבא ינבל",
  "block.minecraft.cracked_stone_bricks": "תוקודס ןבא ינבל",
  "block.minecraft.chiseled_stone_bricks": "תולסופמ ןבא ינבל",
  "block.minecraft.brown_mushroom_block": "תומוח תוירטפ קולב",
  "block.minecraft.red_mushroom_block": "המודא הירטפ קולב",
  "block.minecraft.mushroom_stem": "הירטפ עזג",
  "block.minecraft.iron_bars": "לזרב יגרוס",
  "block.minecraft.chain": "תרשרש",
  "block.minecraft.glass_pane": "תיגוגז",
  "block.minecraft.melon": "חיטבא",
  "block.minecraft.vine": "םינפג",
  "block.minecraft.oak_fence_gate": "ןולא רדג רעש",
  "block.minecraft.spruce_fence_gate": "תיחושא רדג רעש",
  "block.minecraft.birch_fence_gate": "רדש רדג רעש",
  "block.minecraft.jungle_fence_gate": "לגנו'ג ץע רדג רעש",
  "block.minecraft.acacia_fence_gate": "הטיש רדג רעש",
  "block.minecraft.dark_oak_fence_gate": "ההכ ןולא רדג רעש",
  "block.minecraft.crimson_fence_gate": "ןמגרא ץע רדג רעש",
  "block.minecraft.warped_fence_gate": "תתוועמ רדג רעש",
  "block.minecraft.brick_stairs": "םינבל תוגרדמ",
  "block.minecraft.stone_brick_stairs": "ןבא ינבל תוגרדמ",
  "block.minecraft.mycelium": "ריטפת",
  "block.minecraft.lily_pad": "רפונ",
  "block.minecraft.nether_bricks": "ר'תנ ינבל",
  "block.minecraft.cracked_nether_bricks": "תוקודס ר'תנ ינבל",
  "block.minecraft.chiseled_nether_bricks": "תולסופמ ר'תנ ינבל",
  "block.minecraft.nether_brick_fence": "ר'תנ תנבל רדג",
  "block.minecraft.nether_brick_stairs": "ר'תנ תנבל תוגרדמ",
  "block.minecraft.enchanting_table": "ףושיכ ןחלוש",
  "block.minecraft.end_portal_frame": "ףוסה רעש תרגסמ",
  "block.minecraft.end_stone": "דנא ןבא",
  "block.minecraft.end_stone_bricks": "דנא ןבא ינבל",
  "block.minecraft.dragon_egg": "ןוקרד תציב",
  "block.minecraft.redstone_lamp": "ןוטסדר תרונמ",
  "block.minecraft.sandstone_stairs": "לוח ןבא תוגרדמ",
  "block.minecraft.emerald_ore": "תקרב תרפע",
  "block.minecraft.ender_chest": "רדנא תבית",
  "block.minecraft.tripwire_hook": "הדיעמ טוח סרק",
  "block.minecraft.emerald_block": "תקרב קולב",
  "block.minecraft.spruce_stairs": "תיחושא תוגרדמ",
  "block.minecraft.birch_stairs": "רדש תוגרדמ",
  "block.minecraft.jungle_stairs": "לגנו'ג ץע תוגרדמ",
  "block.minecraft.crimson_stairs": "ןמגרא ץע תוגרדמ",
  "block.minecraft.warped_stairs": "תותוועמ תוגרדמ",
  "block.minecraft.command_block": "הדוקפ קולב",
  "block.minecraft.beacon": "האושמ",
  "block.minecraft.cobblestone_wall": "תקסורמ ןבא תמוח",
  "block.minecraft.mossy_cobblestone_wall": "תקסורמ בחט ןבא תמוח",
  "block.minecraft.brick_wall": "םינבל ריק",
  "block.minecraft.prismarine_wall": "ןירמזירפ ריק",
  "block.minecraft.red_sandstone_wall": "המודא לוח ןבא ריק",
  "block.minecraft.mossy_stone_brick_wall": "בחט ןבא ינבל ריק",
  "block.minecraft.granite_wall": "טינרג ריק",
  "block.minecraft.stone_brick_wall": "ןבא ינבל ריק",
  "block.minecraft.nether_brick_wall": "ר'תנ תנבל ריק",
  "block.minecraft.andesite_wall": "טיזדנא ריק",
  "block.minecraft.red_nether_brick_wall": "תומודא ר'תנ ינבל ריק",
  "block.minecraft.sandstone_wall": "לוח ןבא ריק",
  "block.minecraft.end_stone_brick_wall": "דנא ןבא ינבל ריק",
  "block.minecraft.diorite_wall": "טירויד ריק",
  "block.minecraft.blackstone_wall": "הרוחש ןבא ריק",
  "block.minecraft.polished_blackstone_wall": "תשטולמ הרוחש ןבא ריק",
  "block.minecraft.polished_blackstone_brick_wall": "תשטולמ הרוחש ןבא ינבל ריק",
  "block.minecraft.stone_button": "ןבאמ רותפכ",
  "block.minecraft.oak_button": "ןולאמ רותפכ",
  "block.minecraft.spruce_button": "תיחושאמ רותפכ",
  "block.minecraft.birch_button": "רדשמ רותפכ",
  "block.minecraft.jungle_button": "לגנו'ג ץעמ רותפכ",
  "block.minecraft.acacia_button": "הטישמ רותפכ",
  "block.minecraft.dark_oak_button": "ההכ ןולאמ רותפכ",
  "block.minecraft.crimson_button": "ןמגרא ץעמ רותפכ",
  "block.minecraft.warped_button": "תוועמ רותפכ",
  "block.minecraft.polished_blackstone_button": "תשטולמ הרוחש ןבאמ רותפכ",
  "block.minecraft.anvil": "ןדס",
  "block.minecraft.chipped_anvil": "קודס ןדס",
  "block.minecraft.damaged_anvil": "םוגפ ןדס",
  "block.minecraft.trapped_chest": "תדכלוממ הבית",
  "block.minecraft.light_weighted_pressure_plate": "לקשמ תלק ץחל תיחול",
  "block.minecraft.heavy_weighted_pressure_plate": "לקשמ תדבכ ץחל תיחול",
  "block.minecraft.daylight_detector": "םוי רוא ןשייח",
  "block.minecraft.redstone_block": "ןוטסדר קולב",
  "block.minecraft.nether_quartz_ore": "ץרווק ר'תנ תרפע",
  "block.minecraft.hopper": "ךפשמ",
  "block.minecraft.chiseled_quartz_block": "לסופמ ץרווק קולב",
  "block.minecraft.quartz_block": "ץרווק קולב",
  "block.minecraft.quartz_bricks": "ץרווק ינבל",
  "block.minecraft.quartz_pillar": "ץרווק דומע",
  "block.minecraft.quartz_stairs": "ץרווק תוגרדמ",
  "block.minecraft.activator_rail": "הלעפה תליסמ",
  "block.minecraft.dropper": "ןטלופ",
  "block.minecraft.white_terracotta": "הנבל הטוקרט",
  "block.minecraft.orange_terracotta": "המותכ הטוקרט",
  "block.minecraft.magenta_terracotta": "הטנ'גמ הטוקרט",
  "block.minecraft.light_blue_terracotta": "תלכת הטוקרט",
  "block.minecraft.yellow_terracotta": "הבוהצ הטוקרט",
  "block.minecraft.lime_terracotta": "םייל הטוקרט",
  "block.minecraft.pink_terracotta": "הדורו הטוקרט",
  "block.minecraft.gray_terracotta": "הרופא הטוקרט",
  "block.minecraft.light_gray_terracotta": "הריהב הרופא הטוקרט",
  "block.minecraft.cyan_terracotta": "ןאיצ הטוקרט",
  "block.minecraft.purple_terracotta": "הלוגס הטוקרט",
  "block.minecraft.blue_terracotta": "הלוחכ הטוקרט",
  "block.minecraft.brown_terracotta": "המוח הטוקרט",
  "block.minecraft.green_terracotta": "הקורי הטוקרט",
  "block.minecraft.red_terracotta": "המודא הטוקרט",
  "block.minecraft.black_terracotta": "הרוחש הטוקרט",
  "block.minecraft.barrier": "םוסחמ",
  "block.minecraft.iron_trapdoor": "תדכלוממ לזרב תלד",
  "block.minecraft.hay_block": "ריצח תמרע",
  "block.minecraft.white_carpet": "ןבל חיטש",
  "block.minecraft.orange_carpet": "םותכ חיטש",
  "block.minecraft.magenta_carpet": "הטנ'גמ חיטש",
  "block.minecraft.light_blue_carpet": "תלכת חיטש",
  "block.minecraft.yellow_carpet": "בוהצ חיטש",
  "block.minecraft.lime_carpet": "םייל חיטש",
  "block.minecraft.pink_carpet": "דורו חיטש",
  "block.minecraft.gray_carpet": "רופא חיטש",
  "block.minecraft.light_gray_carpet": "ריהב רופא חיטש",
  "block.minecraft.cyan_carpet": "ןאיצ חיטש",
  "block.minecraft.purple_carpet": "לוגס חיטש",
  "block.minecraft.blue_carpet": "לוחכ חיטש",
  "block.minecraft.brown_carpet": "םוח חיטש",
  "block.minecraft.green_carpet": "קורי חיטש",
  "block.minecraft.red_carpet": "םודא חיטש",
  "block.minecraft.black_carpet": "רוחש חיטש",
  "block.minecraft.terracotta": "הטוקרט",
  "block.minecraft.coal_block": "םחפ קולב",
  "block.minecraft.packed_ice": "סוחד חרק",
  "block.minecraft.acacia_stairs": "הטיש תוגרדמ",
  "block.minecraft.dark_oak_stairs": "ההכ ןולא תוגרדמ",
  "block.minecraft.slime_block": "שפר קולב",
  "block.minecraft.grass_path": "אשד ליבש",
  "block.minecraft.sunflower": "תינמח",
  "block.minecraft.lilac": "ךליל",
  "block.minecraft.rose_bush": "םידרו חיש",
  "block.minecraft.peony": "הדורו תינומדא",
  "block.minecraft.tall_grass": "הובג אשד",
  "block.minecraft.large_fern": "לודג ךרש",
  "block.minecraft.white_stained_glass": "הנבל תיכוכז",
  "block.minecraft.orange_stained_glass": "המותכ תיכוכז",
  "block.minecraft.magenta_stained_glass": "הטנ'גמ תיכוכז",
  "block.minecraft.light_blue_stained_glass": "הריהב הלוחכ תיכוכז",
  "block.minecraft.yellow_stained_glass": "הבוהצ תיכוכז",
  "block.minecraft.lime_stained_glass": "םייל תיכוכז",
  "block.minecraft.pink_stained_glass": "הדורו תיכוכז",
  "block.minecraft.gray_stained_glass": "הרופא תיכוכז",
  "block.minecraft.light_gray_stained_glass": "הריהב הרופא תיכוכז",
  "block.minecraft.cyan_stained_glass": "ןאיצ תיכוכז",
  "block.minecraft.purple_stained_glass": "הלוגס תיכוכז",
  "block.minecraft.blue_stained_glass": "הלוחכ תיכוכז",
  "block.minecraft.brown_stained_glass": "המוח תיכוכז",
  "block.minecraft.green_stained_glass": "הקורי תיכוכז",
  "block.minecraft.red_stained_glass": "המודא תיכוכז",
  "block.minecraft.black_stained_glass": "הרוחש תיכוכז",
  "block.minecraft.white_stained_glass_pane": "הנבל תיגוגז",
  "block.minecraft.orange_stained_glass_pane": "המותכ תיגוגז",
  "block.minecraft.magenta_stained_glass_pane": "הטנ'גמ תיגוגז",
  "block.minecraft.light_blue_stained_glass_pane": "תלכת תיגוגז",
  "block.minecraft.yellow_stained_glass_pane": "הבוהצ תיגוגז",
  "block.minecraft.lime_stained_glass_pane": "םייל תיגוגז",
  "block.minecraft.pink_stained_glass_pane": "הדורו תיגוגז",
  "block.minecraft.gray_stained_glass_pane": "הרופא תיגוגז",
  "block.minecraft.light_gray_stained_glass_pane": "הריהב הרופא תיגוגז",
  "block.minecraft.cyan_stained_glass_pane": "ןאיצ תיגוגז",
  "block.minecraft.purple_stained_glass_pane": "הלוגס תיגוגז",
  "block.minecraft.blue_stained_glass_pane": "הלוחכ תיגוגז",
  "block.minecraft.brown_stained_glass_pane": "המוח תיגוגז",
  "block.minecraft.green_stained_glass_pane": "הקורי תיגוגז",
  "block.minecraft.red_stained_glass_pane": "המודא תיגוגז",
  "block.minecraft.black_stained_glass_pane": "הרוחש תיגוגז",
  "block.minecraft.prismarine": "ןירמזירפ",
  "block.minecraft.prismarine_bricks": "ןירמזירפ ינבל",
  "block.minecraft.dark_prismarine": "ההכ ןירמזירפ",
  "block.minecraft.prismarine_stairs": "ןירמזירפ תוגרדמ",
  "block.minecraft.prismarine_brick_stairs": "ןירמזירפ תנבל תוגרדמ",
  "block.minecraft.dark_prismarine_stairs": "ההכ ןירמזירפ תוגרדמ",
  "block.minecraft.sea_lantern": "םי תרונמ",
  "block.minecraft.red_sandstone": "המודא לוח ןבא",
  "block.minecraft.chiseled_red_sandstone": "תלסופמ המודא לוח ןבא",
  "block.minecraft.cut_red_sandstone": "הכותח המודא לוח ןבא",
  "block.minecraft.red_sandstone_stairs": "המודא לוח ןבא תוגרדמ",
  "block.minecraft.repeating_command_block": "ירוזחמ הדוקפ קולב",
  "block.minecraft.chain_command_block": "תרשרושמ הדוקפ תייבוק",
  "block.minecraft.magma_block": "המגאמ תייבוק",
  "block.minecraft.nether_wart_block": "ר'תנ תלוביש קולב",
  "block.minecraft.warped_wart_block": "תוועמ ר'תנ תלוביש קולב",
  "block.minecraft.red_nether_bricks": "תומודא ר'תנ ינבל",
  "block.minecraft.bone_block": "םצע תייבוק",
  "block.minecraft.structure_void": "הנבמ ללח",
  "block.minecraft.observer": "ןתיפצת",
  "block.minecraft.shulker_box": "רקלוש תבית",
  "block.minecraft.white_shulker_box": "הנבל רקלוש תבית",
  "block.minecraft.orange_shulker_box": "המותכ רקלוש תבית",
  "block.minecraft.magenta_shulker_box": "הטנ'גמ רקלוש תבית",
  "block.minecraft.light_blue_shulker_box": "תלכת רקלוש תבית",
  "block.minecraft.yellow_shulker_box": "הבוהצ רקלוש תבית",
  "block.minecraft.lime_shulker_box": "םייל רקלוש תבית",
  "block.minecraft.pink_shulker_box": "הדורו רקלוש תבית",
  "block.minecraft.gray_shulker_box": "הרופא רקלוש תבית",
  "block.minecraft.light_gray_shulker_box": "הריהב הרופא רקלוש תבית",
  "block.minecraft.cyan_shulker_box": "ןאיצ רקלוש תבית",
  "block.minecraft.purple_shulker_box": "הלוגס רקלוש תבית",
  "block.minecraft.blue_shulker_box": "הלוחכ רקלוש תבית",
  "block.minecraft.brown_shulker_box": "המוח רקלוש תבית",
  "block.minecraft.green_shulker_box": "הקורי רקלוש תבית",
  "block.minecraft.red_shulker_box": "המודא רקלוש תבית",
  "block.minecraft.black_shulker_box": "הרוחש רקלוש תבית",
  "block.minecraft.white_glazed_terracotta": "הנבל תגגוזמ הטוקרט",
  "block.minecraft.orange_glazed_terracotta": "המותכ תגגוזמ הטוקרט",
  "block.minecraft.magenta_glazed_terracotta": "הטנ'גמ תגגוזמ הטוקרט",
  "block.minecraft.light_blue_glazed_terracotta": "תלכת תגגוזמ הטוקרט",
  "block.minecraft.yellow_glazed_terracotta": "הבוהצ תגגוזמ הטוקרט",
  "block.minecraft.lime_glazed_terracotta": "םייל תגגוזמ הטוקרט",
  "block.minecraft.pink_glazed_terracotta": "הדורו תגגוזמ הטוקרט",
  "block.minecraft.gray_glazed_terracotta": "הרופא תגגוזמ הטוקרט",
  "block.minecraft.light_gray_glazed_terracotta": "הריהב הרופא תגגוזמ הטוקרט",
  "block.minecraft.cyan_glazed_terracotta": "ןאיצ תגגוזמ הטוקרט",
  "block.minecraft.purple_glazed_terracotta": "הלוגס תגגוזמ הטוקרט",
  "block.minecraft.blue_glazed_terracotta": "הלוחכ תגגוזמ הטוקרט",
  "block.minecraft.brown_glazed_terracotta": "המוח תגגוזמ הטוקרט",
  "block.minecraft.green_glazed_terracotta": "הקורי תגגוזמ הטוקרט",
  "block.minecraft.red_glazed_terracotta": "המודא תגגוזמ הטוקרט",
  "block.minecraft.black_glazed_terracotta": "הרוחש תגגוזמ הטוקרט",
  "block.minecraft.white_concrete": "ןבל ןוטב",
  "block.minecraft.orange_concrete": "םותכ ןוטב",
  "block.minecraft.magenta_concrete": "הטנ'גמ ןוטב",
  "block.minecraft.light_blue_concrete": "תלכת ןוטב",
  "block.minecraft.yellow_concrete": "בוהצ ןוטב",
  "block.minecraft.lime_concrete": "םייל ןוטב",
  "block.minecraft.pink_concrete": "דורו ןוטב",
  "block.minecraft.gray_concrete": "רופא ןוטב",
  "block.minecraft.light_gray_concrete": "ריהב רופא ןוטב",
  "block.minecraft.cyan_concrete": "ןאיצ ןוטב",
  "block.minecraft.purple_concrete": "לוגס ןוטב",
  "block.minecraft.blue_concrete": "לוחכ ןוטב",
  "block.minecraft.brown_concrete": "םוח ןוטב",
  "block.minecraft.green_concrete": "קורי ןוטב",
  "block.minecraft.red_concrete": "םודא ןוטב",
  "block.minecraft.black_concrete": "רוחש ןוטב",
  "block.minecraft.white_concrete_powder": "הנבל ןוטב תקבא",
  "block.minecraft.orange_concrete_powder": "המותכ ןוטב תקבא",
  "block.minecraft.magenta_concrete_powder": "הטנ'גמ ןוטב תקבא",
  "block.minecraft.light_blue_concrete_powder": "תלכת ןוטב תקבא",
  "block.minecraft.yellow_concrete_powder": "הבוהצ ןוטב תקבא",
  "block.minecraft.lime_concrete_powder": "םייל ןוטב תקבא",
  "block.minecraft.pink_concrete_powder": "הדורו ןוטב תקבא",
  "block.minecraft.gray_concrete_powder": "הרופא ןוטב תקבא",
  "block.minecraft.light_gray_concrete_powder": "הריהב הרופא ןוטב תקבא",
  "block.minecraft.cyan_concrete_powder": "ןאיצ ןוטב תקבא",
  "block.minecraft.purple_concrete_powder": "הלוגס ןוטב תקבא",
  "block.minecraft.blue_concrete_powder": "הלוחכ ןוטב תקבא",
  "block.minecraft.brown_concrete_powder": "המוח ןוטב תקבא",
  "block.minecraft.green_concrete_powder": "הקורי ןוטב תקבא",
  "block.minecraft.red_concrete_powder": "המודא ןוטב תקבא",
  "block.minecraft.black_concrete_powder": "הרוחש ןוטב תקבא",
  "block.minecraft.turtle_egg": "בצ תציב",
  "block.minecraft.dead_tube_coral_block": "תמ ירוניצ גומלא",
  "block.minecraft.dead_brain_coral_block": "תמ יחומ גומלא",
  "block.minecraft.dead_bubble_coral_block": "תמ תועוב גומלא",
  "block.minecraft.dead_fire_coral_block": "תמ שא גומלא",
  "block.minecraft.dead_horn_coral_block": "תמ ןרק גומלא",
  "block.minecraft.tube_coral_block": "ירוניצ גומלא",
  "block.minecraft.brain_coral_block": "יחומ גומלא",
  "block.minecraft.bubble_coral_block": "תועוב גומלא",
  "block.minecraft.fire_coral_block": "שא גומלא",
  "block.minecraft.horn_coral_block": "ןרק גומלא",
  "block.minecraft.tube_coral": "ירוניצ גומלא חמצ",
  "block.minecraft.brain_coral": "יחומ גומלא חמצ",
  "block.minecraft.bubble_coral": "תועוב גומלא חמצ",
  "block.minecraft.fire_coral": "שא גומלא חמצ",
  "block.minecraft.horn_coral": "ןרק גומלא חמצ",
  "block.minecraft.dead_brain_coral": "תמ יחומ גומלא",
  "block.minecraft.dead_bubble_coral": "תמ תועוב גומלא",
  "block.minecraft.dead_fire_coral": "תמ שא גומלא",
  "block.minecraft.dead_horn_coral": "תמ ןרק גומלא",
  "block.minecraft.dead_tube_coral": "תמ ירוניצ גומלא",
  "block.minecraft.tube_coral_fan": "ירוניצ גומלא ףנע",
  "block.minecraft.brain_coral_fan": "יחומ גומלא ףנע",
  "block.minecraft.bubble_coral_fan": "תועוב גומלא ףנע",
  "block.minecraft.fire_coral_fan": "שא גומלא ףנע",
  "block.minecraft.horn_coral_fan": "ןרק גומלא ףנע",
  "block.minecraft.dead_tube_coral_fan": "תמ ירוניצ גומלא ףנע",
  "block.minecraft.dead_brain_coral_fan": "תמ יחומ גומלא ףנע",
  "block.minecraft.dead_bubble_coral_fan": "תמ תועוב גומלא ףנע",
  "block.minecraft.dead_fire_coral_fan": "תמ שא גומלא ףנע",
  "block.minecraft.dead_horn_coral_fan": "תמ ןרק גומלא ףנע",
  "block.minecraft.blue_ice": "לוחכ חרק",
  "block.minecraft.conduit": "םימ תביל",
  "block.minecraft.polished_granite_stairs": "שטולמ טינרג תוגרדמ",
  "block.minecraft.smooth_red_sandstone_stairs": "הקלח המודא לוח ןבא תוגרדמ",
  "block.minecraft.mossy_stone_brick_stairs": "בחט ןבא ינבל תוגרדמ",
  "block.minecraft.polished_diorite_stairs": "שטולמ טירויד תוגרדמ",
  "block.minecraft.mossy_cobblestone_stairs": "תקסורמ בחט ןבא תוגרדמ",
  "block.minecraft.end_stone_brick_stairs": "דנא ןבא ינבל תוגרדמ",
  "block.minecraft.stone_stairs": "ןבא תוגרדמ",
  "block.minecraft.smooth_sandstone_stairs": "הקלח לוח ןבא תוגרדמ",
  "block.minecraft.smooth_quartz_stairs": "קלח ץרווק תוגרדמ",
  "block.minecraft.granite_stairs": "טינרג תוגרדמ",
  "block.minecraft.andesite_stairs": "טיזדנא תוגרדמ",
  "block.minecraft.red_nether_brick_stairs": "תומודא ר'תנ ינבל תוגרדמ",
  "block.minecraft.polished_andesite_stairs": "שטולמ טיזנא תוגרדמ",
  "block.minecraft.diorite_stairs": "טירויד תוגרדמ",
  "block.minecraft.polished_granite_slab": "יוצח שטולמ טינרג",
  "block.minecraft.smooth_red_sandstone_slab": "היוצח הקלח המודא לוח ןבא",
  "block.minecraft.mossy_stone_brick_slab": "תויוצח בחט ןבא ינבל",
  "block.minecraft.polished_diorite_slab": "יוצח שטולמ טירויד",
  "block.minecraft.mossy_cobblestone_slab": "היוצח תקסורמ בחט ןבא",
  "block.minecraft.end_stone_brick_slab": "תויוצח דנא ןבא ינבל",
  "block.minecraft.smooth_sandstone_slab": "היוצח הקלח לוח ןבא",
  "block.minecraft.smooth_quartz_slab": "יוצח קלח ץרווק",
  "block.minecraft.granite_slab": "יוצח טינרג",
  "block.minecraft.andesite_slab": "יוצח טיזדנא",
  "block.minecraft.red_nether_brick_slab": "תויוצח תומודא ר'תנ ינבל",
  "block.minecraft.polished_andesite_slab": "יוצח שטולמ טיזנא",
  "block.minecraft.diorite_slab": "יוצח טירויד",
  "block.minecraft.scaffolding": "םוגיפ",
  "block.minecraft.iron_door": "לזרב תלד",
  "block.minecraft.oak_door": "ןולא תלד",
  "block.minecraft.spruce_door": "תיחושא תלד",
  "block.minecraft.birch_door": "רדש תלד",
  "block.minecraft.jungle_door": "לגנו'ג ץע תלד",
  "block.minecraft.acacia_door": "הטיש תלד",
  "block.minecraft.dark_oak_door": "ההכ ןולא תלד",
  "block.minecraft.crimson_door": "ןמגרא ץע תלד",
  "block.minecraft.warped_door": "תתוועמ תלד",
  "block.minecraft.repeater": "ןוטסדר רזחשמ",
  "block.minecraft.comparator": "ןוטסדר םרז הוושמ",
  "block.minecraft.structure_block": "הנבמ קולב",
  "block.minecraft.jigsaw": "לזאפ קולב",
  "item.minecraft.turtle_helmet": "בצ ןוירש□□:שארה לע רשאכ□ןוירש 2+",
  "item.minecraft.scute": "בצ שקשק",
  "item.minecraft.iron_shovel": "לזרב תא□□:תישארה דיב רשאכ□הפיקת חוכ 3.5+□הפיקת תוריהמ 3-",
  "item.minecraft.iron_pickaxe": "לזרב שוכמ□□:תישארה דיב רשאכ□הפיקת חוכ 3+□הפיקת תוריהמ 2.8-",
  "item.minecraft.iron_axe": "לזרב ןזרג□□:תישארה דיב רשאכ□הפיקת חוכ 8+□הפיקת תוריהמ 3.1-",
  "item.minecraft.flint_and_steel": "הדלפו רוצ",
  "item.minecraft.apple": "חופת",
  "item.minecraft.bow": "תשק",
  "item.minecraft.arrow": "ץח",
  "item.minecraft.coal": "םחפ",
  "item.minecraft.charcoal": "ץע םחפ",
  "item.minecraft.diamond": "םולהי",
  "item.minecraft.iron_ingot": "לזרב ליטמ",
  "item.minecraft.gold_ingot": "בהז ליטמ",
  "item.minecraft.netherite_ingot": "טייר'תנ ליטמ",
  "item.minecraft.netherite_scrap": "ץפונמ טייר'תנ",
  "item.minecraft.iron_sword": "לזרב ברח□□:תישארה דיב רשאכ□הפיקת חוכ 5+□הפיקת תוריהמ 2.4-",
  "item.minecraft.wooden_sword": "ץע ברח□□:תישארה דיב רשאכ□הפיקת חוכ 3+□הפיקת תוריהמ 2.4-",
  "item.minecraft.wooden_shovel": "ץע תא□□:תישארה דיב רשאכ□הפיקת חוכ 1.5+□הפיקת תוריהמ 3-",
  "item.minecraft.wooden_pickaxe": "ץע שוכמ□□:תישארה דיב רשאכ□הפיקת חוכ 1+□הפיקת תוריהמ 2.8-",
  "item.minecraft.wooden_axe": "ץע ןזרג□□:תישארה דיב רשאכ□הפיקת חוכ 6+□הפיקת תוריהמ 3.2-",
  "item.minecraft.stone_sword": "ןבא ברח□□:תישארה דיב רשאכ□הפיקת חוכ 4+□הפיקת תוריהמ 2.4-",
  "item.minecraft.stone_shovel": "ןבא תא□□:תישארה דיב רשאכ□הפיקת חוכ 2.5+□הפיקת תוריהמ 3-",
  "item.minecraft.stone_pickaxe": "ןבא שוכמ□□:תישארה דיב רשאכ□הפיקת חוכ 2+□הפיקת תוריהמ 2.8-",
  "item.minecraft.stone_axe": "ןבא ןזרג□□:תישארה דיב רשאכ□הפיקת חוכ 8+□הפיקת תוריהמ 3.2-",
  "item.minecraft.diamond_sword": "םולהי ברח□□:תישארה דיב רשאכ□הפיקת חוכ 6+□הפיקת תוריהמ 2.4-",
  "item.minecraft.diamond_shovel": "םולהי תא□□:תישארה דיב רשאכ□הפיקת חוכ 4.5+□הפיקת תוריהמ 3-",
  "item.minecraft.diamond_pickaxe": "םולהי שוכמ□□:תישארה דיב רשאכ□הפיקת חוכ 4+□הפיקת תוריהמ 2.8-",
  "item.minecraft.diamond_axe": "םולהי ןזרג□□:תישארה דיב רשאכ□הפיקת חוכ 8+□הפיקת תוריהמ 3-",
  "item.minecraft.stick": "לקמ",
  "item.minecraft.bowl": "הרעק",
  "item.minecraft.mushroom_stew": "תוירטפ לישבת",
  "item.minecraft.golden_sword": "בהז ברח□□:תישארה דיב רשאכ□הפיקת חוכ 3+□הפיקת תוריהמ 2.4-",
  "item.minecraft.golden_shovel": "בהז תא□□:תישארה דיב רשאכ□הפיקת חוכ 1.5+□הפיקת תוריהמ 3-",
  "item.minecraft.golden_pickaxe": "בהז שוכמ□□:תישארה דיב רשאכ□הפיקת חוכ 1+□הפיקת תוריהמ 2.8-",
  "item.minecraft.golden_axe": "בהז ןזרג□□:תישארה דיב רשאכ□הפיקת חוכ 6+□הפיקת תוריהמ 3-",
  "item.minecraft.netherite_sword": "טייר'תנ ברח□□:תישארה דיב רשאכ□הפיקת חוכ 7+□הפיקת תוריהמ 2.4-",
  "item.minecraft.netherite_shovel": "טייר'תנ תא□□:תישארה דיב רשאכ□הפיקת חוכ 5.5+□הפיקת תוריהמ 3-",
  "item.minecraft.netherite_pickaxe": "טייר'תנ שוכמ□□:תישארה דיב רשאכ□הפיקת חוכ 5+□הפיקת תוריהמ 2.8-",
  "item.minecraft.netherite_axe": "טייר'תנ ןזרג□□:תישארה דיב רשאכ□הפיקת חוכ 9+□הפיקת תוריהמ 3-",
  "item.minecraft.string": "טוח",
  "item.minecraft.feather": "הצונ",
  "item.minecraft.gunpowder": "הפירש קבא",
  "item.minecraft.wooden_hoe": "ץע רדעמ□□:תישארה דיב רשאכ□הפיקת תוריהמ 3-",
  "item.minecraft.stone_hoe": "ןבא רדעמ□□:תישארה דיב רשאכ□הפיקת תוריהמ 2-",
  "item.minecraft.iron_hoe": "לזרב רדעמ□□:תישארה דיב רשאכ□הפיקת תוריהמ 1-",
  "item.minecraft.diamond_hoe": "םולהי רדעמ□□:תישארה דיב רשאכ",
  "item.minecraft.golden_hoe": "בהז רדעמ□□:תישארה דיב רשאכ□הפיקת תוריהמ 3-",
  "item.minecraft.netherite_hoe": "טייר'תנ רדעמ□□:תישארה דיב רשאכ",
  "item.minecraft.wheat_seeds": "הטיח יערז",
  "item.minecraft.wheat": "הטיח",
  "item.minecraft.bread": "םחל",
  "item.minecraft.leather_helmet": "רוע עבוכ□□:שארה לע רשאכ□ןוירש 1+",
  "item.minecraft.leather_chestplate": "רוע תקינוט□□:ףוגה לע רשאכ□ןוירש 3+",
  "item.minecraft.leather_leggings": "רוע יסנכמ□□:םייסנכמה לע רשאכ□ןוירש 2+",
  "item.minecraft.leather_boots": "רוע יפגמ□□:םיילגרה לע רשאכ□ןוירש 1+",
  "item.minecraft.chainmail_helmet": "לזרב תוארשרש תדסק□□:שארה לע רשאכ□ןוירש 2+",
  "item.minecraft.chainmail_chestplate": "לזרב תוארשרש ןוירש□□:ףוגה לע רשאכ□ןוירש 5+",
  "item.minecraft.chainmail_leggings": "לזרב תוארשרש יסנכמ□□:םייסנכמה לע רשאכ□ןוירש 4+",
  "item.minecraft.chainmail_boots": "לזרב תוארשרש יפגמ□□:םיילגרה לע רשאכ□ןוירש 1+",
  "item.minecraft.iron_helmet": "לזרב תדסק□□:שארה לע רשאכ□ןוירש 2+",
  "item.minecraft.iron_chestplate": "לזרב ןוירש□□:ףוגה לע רשאכ□ןוירש 6+",
  "item.minecraft.iron_leggings": "לזרב יסנכמ□□:םייסנכמה לע רשאכ□ןוירש 5+",
  "item.minecraft.iron_boots": "לזרב יפגמ□□:םיילגרה לע רשאכ□ןוירש 2+",
  "item.minecraft.diamond_helmet": "םולהי תדסק□□:שארה לע רשאכ□ןוירש 3+□ןוירש תוחישק 2+",
  "item.minecraft.diamond_chestplate": "םולהי ןוירש□□:ףוגה לע רשאכ□ןוירש 8+□ןוירש תוחישק 2+",
  "item.minecraft.diamond_leggings": "םולהי יסנכמ□□:םייסנכמה לע רשאכ□ןוירש 6+□ןוירש תוחישק 2+",
  "item.minecraft.diamond_boots": "םולהי יפגמ□□:םיילגרה לע רשאכ□ןוירש 3+□ןוירש תוחישק 2+",
  "item.minecraft.golden_helmet": "בהז תדסק□□:שארה לע רשאכ□ןוירש 2+",
  "item.minecraft.golden_chestplate": "בהז ןוירש□□:ףוגה לע רשאכ□ןוירש 5+",
  "item.minecraft.golden_leggings": "בהז יסנכמ□□:םייסנכמה לע רשאכ□ןוירש 3+",
  "item.minecraft.golden_boots": "בהז יפגמ□□:םיילגרה לע רשאכ□ןוירש 1+",
  "item.minecraft.netherite_helmet": "טייר'תנ תדסק□□:שארה לע רשאכ□ןוירש 3+□ןוירש תוחישק 3+□הייחד תודגנתה 1+",
  "item.minecraft.netherite_chestplate": "טייר'תנ ןוירש□□:ףוגה לע רשאכ□ןוירש 8+□ןוירש תוחישק 3+□הייחד תודגנתה 1+",
  "item.minecraft.netherite_leggings": "טייר'תנ יסנכמ□□:םייסנכמה לע רשאכ□ןוירש 6+□ןוירש תוחישק 3+□הייחד תודגנתה 1+",
  "item.minecraft.netherite_boots": "טייר'תנ יפגמ□□:םיילגרה לע רשאכ□ןוירש 3+□ןוירש תוחישק 3+□הייחד תודגנתה 1+",
  "item.minecraft.flint": "רוצ",
  "item.minecraft.porkchop": "אנ ריזח עלצ",
  "item.minecraft.cooked_porkchop": "תלשובמ ריזח עלצ",
  "item.minecraft.painting": "רויצ",
  "item.minecraft.golden_apple": "בהזומ חופת",
  "item.minecraft.enchanted_golden_apple": "ףשוכמ בהזומ חופת",
  "block.minecraft.oak_sign": "ןולא טלש",
  "block.minecraft.spruce_sign": "תיחושא טלש",
  "block.minecraft.birch_sign": "רדש טלש",
  "block.minecraft.jungle_sign": "לגנו'ג ץע טלש",
  "block.minecraft.acacia_sign": "הטיש טלש",
  "block.minecraft.dark_oak_sign": "ההכ ןולא טלש",
  "block.minecraft.crimson_sign": "ןמגרא ץעמ טלש",
  "block.minecraft.warped_sign": "תוועמ טלש",
  "item.minecraft.bucket": "ילד",
  "item.minecraft.water_bucket": "םימ ילד",
  "item.minecraft.lava_bucket": "הבל ילד",
  "item.minecraft.minecart": "תינורק",
  "item.minecraft.saddle": "ףכוא",
  "item.minecraft.redstone": "ןוטסדר קבא",
  "item.minecraft.snowball": "גלש רודכ",
  "item.minecraft.oak_boat": "ןולא תריס",
  "item.minecraft.leather": "רוע",
  "item.minecraft.milk_bucket": "בלח ילד",
  "item.minecraft.pufferfish_bucket": "אחפנ ובא ילד",
  "item.minecraft.salmon_bucket": "ןומלס ילד",
  "item.minecraft.cod_bucket": "הלקב ילד",
  "item.minecraft.tropical_fish_bucket": "יפורט גד ילד",
  "item.minecraft.brick": "הנבל",
  "item.minecraft.clay_ball": "רמיח",
  "block.minecraft.dried_kelp_block": "תשבוימ הצא קולב",
  "item.minecraft.paper": "ריינ",
  "item.minecraft.book": "רפס",
  "item.minecraft.slime_ball": "שפר רודכ",
  "item.minecraft.chest_minecart": "הבית םע תינורק",
  "item.minecraft.furnace_minecart": "רונת םע תינורק",
  "item.minecraft.egg": "הציב",
  "item.minecraft.compass": "ןפצמ",
  "item.minecraft.fishing_rod": "גיד תכח",
  "item.minecraft.clock": "ןועש",
  "item.minecraft.glowstone_dust": "ןוטסולג קבא",
  "item.minecraft.cod": "אנ הלקב",
  "item.minecraft.salmon": "אנ ןומלס",
  "item.minecraft.tropical_fish": "יפורט גד",
  "item.minecraft.pufferfish": "אחפנ-ובא",
  "item.minecraft.cooked_cod": "יופא הלקב",
  "item.minecraft.cooked_salmon": "לשובמ ןומלס",
  "item.minecraft.ink_sac": "ויד קש",
  "item.minecraft.red_dye": "םודא עבצ",
  "item.minecraft.green_dye": "קורי עבצ",
  "item.minecraft.cocoa_beans": "ואקק ילופ",
  "item.minecraft.lapis_lazuli": "ילוזאל סיפאל",
  "item.minecraft.purple_dye": "לוגס עבצ",
  "item.minecraft.cyan_dye": "ןאיצ עבצ",
  "item.minecraft.light_gray_dye": "ריהב רופא עבצ",
  "item.minecraft.gray_dye": "רופא עבצ",
  "item.minecraft.pink_dye": "דורו עבצ",
  "item.minecraft.lime_dye": "םייל עבצ",
  "item.minecraft.yellow_dye": "בוהצ עבצ",
  "item.minecraft.light_blue_dye": "תלכת עבצ",
  "item.minecraft.magenta_dye": "הטנ'גמ עבצ",
  "item.minecraft.orange_dye": "םותכ עבצ",
  "item.minecraft.bone_meal": "ןשד",
  "item.minecraft.blue_dye": "לוחכ עבצ",
  "item.minecraft.brown_dye": "םוח עבצ",
  "item.minecraft.black_dye": "רוחש עבצ",
  "item.minecraft.white_dye": "ןבל עבצ",
  "item.minecraft.bone": "םצע",
  "item.minecraft.sugar": "רכוס",
  "block.minecraft.cake": "הגוע",
  "block.minecraft.white_bed": "הנבל הטימ",
  "block.minecraft.orange_bed": "המותכ הטימ",
  "block.minecraft.magenta_bed": "הטנ'גמ הטימ",
  "block.minecraft.light_blue_bed": "תלכת הטימ",
  "block.minecraft.yellow_bed": "הבוהצ הטימ",
  "block.minecraft.lime_bed": "םייל הטימ",
  "block.minecraft.pink_bed": "הדורו הטימ",
  "block.minecraft.gray_bed": "הרופא הטימ",
  "block.minecraft.light_gray_bed": "תלכת הטימ",
  "block.minecraft.cyan_bed": "ןאיצ הטימ",
  "block.minecraft.purple_bed": "הלוגס הטימ",
  "block.minecraft.blue_bed": "הלוחכ הטימ",
  "block.minecraft.brown_bed": "המוח הטימ",
  "block.minecraft.green_bed": "הקורי הטימ",
  "block.minecraft.red_bed": "המודא הטימ",
  "block.minecraft.black_bed": "הרוחש הטימ",
  "item.minecraft.cookie": "הייגוע",
  "item.minecraft.filled_map": "הפמ□#0",
  "item.minecraft.shears": "הרמזמ",
  "item.minecraft.melon_slice": "חיטבא תסורפ",
  "item.minecraft.dried_kelp": "תשבוימ הצא",
  "item.minecraft.pumpkin_seeds": "תעלד יערז",
  "item.minecraft.melon_seeds": "חיטבא יערז",
  "item.minecraft.beef": "אנ רקב",
  "item.minecraft.cooked_beef": "קייטס",
  "item.minecraft.chicken": "אנ ףוע",
  "item.minecraft.cooked_chicken": "לשובמ ףוע",
  "item.minecraft.rotten_flesh": "בוקר רשב",
  "item.minecraft.ender_pearl": "רדנא תנינפ",
  "item.minecraft.blaze_rod": "ןובהל טומ",
  "item.minecraft.ghast_tear": "טסאג תעמד",
  "item.minecraft.gold_nugget": "בהז שוג",
  "item.minecraft.nether_wart": "ר'תנ תלוביש",
  "item.minecraft.potion": "הנכהל ןתינ יתלב יוקיש□העפשה רסח",
  "item.minecraft.glass_bottle": "תיכוכז קובקב",
  "item.minecraft.spider_eye": "שיבכע ןיע",
  "item.minecraft.fermented_spider_eye": "הסוסת שיבכע ןיע",
  "item.minecraft.blaze_powder": "ןובהל תקבא",
  "item.minecraft.magma_cream": "המגאמ םרק",
  "block.minecraft.brewing_stand": "החיקר תדמע",
  "block.minecraft.cauldron": "הרדק",
  "item.minecraft.ender_eye": "רדנא ןיע",
  "item.minecraft.glistering_melon_slice": "ץנצנמ חיטבא תסורפ",
  "item.minecraft.bat_spawn_egg": "ףלטע ןומיז תציב",
  "item.minecraft.bee_spawn_egg": "הרובד ןומיז תציב",
  "item.minecraft.blaze_spawn_egg": "ןובהל ןומיז תציב",
  "item.minecraft.cat_spawn_egg": "לותח ןומיז תציב",
  "item.minecraft.cave_spider_spawn_egg": "תורעמ שיבכע ןומיז תציב",
  "item.minecraft.chicken_spawn_egg": "לוגנרת ןומיז תציב",
  "item.minecraft.cod_spawn_egg": "הלקב ןומיז תציב",
  "item.minecraft.cow_spawn_egg": "הרפ ןומיז תציב",
  "item.minecraft.creeper_spawn_egg": "רפירק ןומיז תציב",
  "item.minecraft.dolphin_spawn_egg": "ןיפלוד ןומיז תציב",
  "item.minecraft.donkey_spawn_egg": "רומח ןומיז תציב",
  "item.minecraft.drowned_spawn_egg": "עובט ןומיז תציב",
  "item.minecraft.elder_guardian_spawn_egg": "קיתע רמוש ןומיז תציב",
  "item.minecraft.enderman_spawn_egg": "ןמרדנא ןומיז תציב",
  "item.minecraft.endermite_spawn_egg": "טיימרדנא ןומיז תציב",
  "item.minecraft.evoker_spawn_egg": "ררועמ ןומיז תציב",
  "item.minecraft.fox_spawn_egg": "לעוש ןומיז תציב",
  "item.minecraft.ghast_spawn_egg": "טסאג ןומיז תציב",
  "item.minecraft.guardian_spawn_egg": "רמוש ןומיז תציב",
  "item.minecraft.hoglin_spawn_egg": "ןילגוה ןומיז תציב",
  "item.minecraft.horse_spawn_egg": "סוס ןומיז תציב",
  "item.minecraft.husk_spawn_egg": "קסאה ןומיז תציב",
  "item.minecraft.llama_spawn_egg": "המל ןומיז תציב",
  "item.minecraft.magma_cube_spawn_egg": "המגאמ תייבוק ןומיז תציב",
  "item.minecraft.mooshroom_spawn_egg": "םורשומ ןומיז תציב",
  "item.minecraft.mule_spawn_egg": "דרפ ןומיז תציב",
  "item.minecraft.ocelot_spawn_egg": "טולצוא ןומיז תציב",
  "item.minecraft.panda_spawn_egg": "הדנפ ןומיז תציב",
  "item.minecraft.parrot_spawn_egg": "יכות ןומיז תציב",
  "item.minecraft.phantom_spawn_egg": "םוטנאפ ןומיז תציב",
  "item.minecraft.pig_spawn_egg": "ריזח ןומיז תציב",
  "item.minecraft.piglin_spawn_egg": "ןילגיפ ןומיז תציב",
  "item.minecraft.pillager_spawn_egg": "םירפכ דדוש ןומיז תציב",
  "item.minecraft.polar_bear_spawn_egg": "בטוק בוד ןומיז תציב",
  "item.minecraft.pufferfish_spawn_egg": "אחפנ ובא ןומיז תציב",
  "item.minecraft.rabbit_spawn_egg": "בנרא ןומיז תציב",
  "item.minecraft.ravager_spawn_egg": "ןסרה ןומיז תציב",
  "item.minecraft.salmon_spawn_egg": "ןומלס ןומיז תציב",
  "item.minecraft.sheep_spawn_egg": "השבכ ןומיז תציב",
  "item.minecraft.shulker_spawn_egg": "רקלוש ןומיז תציב",
  "item.minecraft.silverfish_spawn_egg": "ףסכ גד ןומיז תציב",
  "item.minecraft.skeleton_spawn_egg": "דלש ןומיז תציב",
  "item.minecraft.skeleton_horse_spawn_egg": "סוס דלש ןומיז תציב",
  "item.minecraft.slime_spawn_egg": "שפר ןומיז תציב",
  "item.minecraft.spider_spawn_egg": "שיבכע ןומיז תציב",
  "item.minecraft.squid_spawn_egg": "ןונויד ןומיז תציב",
  "item.minecraft.stray_spawn_egg": "העות ןומיז תציב",
  "item.minecraft.strider_spawn_egg": "רדיירטס ןומיז תציב",
  "item.minecraft.trader_llama_spawn_egg": "רחוס לש המל ןומיז תציב",
  "item.minecraft.tropical_fish_spawn_egg": "יפורט גד ןומיז תציב",
  "item.minecraft.turtle_spawn_egg": "בצ ןומיז תציב",
  "item.minecraft.vex_spawn_egg": "סקוו ןומיז תציב",
  "item.minecraft.villager_spawn_egg": "ירפכ ןומיז תציב",
  "item.minecraft.vindicator_spawn_egg": "שטרמ ןומיז תציב",
  "item.minecraft.wandering_trader_spawn_egg": "דדונ רחוס ןומיז תציב",
  "item.minecraft.witch_spawn_egg": "הפשכמ ןומיז תציב",
  "item.minecraft.wither_skeleton_spawn_egg": "ר'תיוו דלש ןומיז תציב",
  "item.minecraft.wolf_spawn_egg": "באז ןומיז תציב",
  "item.minecraft.zoglin_spawn_egg": "ןילגוז ןומיז תציב",
  "item.minecraft.zombie_spawn_egg": "יבמוז ןומיז תציב",
  "item.minecraft.zombie_horse_spawn_egg": "יבמוז סוס ןומיז תציב",
  "item.minecraft.zombie_villager_spawn_egg": "ירפכ יבמוז ןומיז תציב",
  "item.minecraft.zombified_piglin_spawn_egg": "יבמוז ןילגיפ ןומיז תציב",
  "item.minecraft.experience_bottle": "םיפושיכ קובקב",
  "item.minecraft.fire_charge": "שא רודכ",
  "item.minecraft.writable_book": "סומלוקו רפס",
  "item.minecraft.written_book": "בותכ רפס",
  "item.minecraft.emerald": "תקרב",
  "item.minecraft.item_frame": "טירפ תרגסמ",
  "block.minecraft.flower_pot": "ץיצע",
  "item.minecraft.carrot": "רזג",
  "item.minecraft.potato": "המדא חופת",
  "item.minecraft.baked_potato": "יופא המדא חופת",
  "item.minecraft.poisonous_potato": "לערומ המדא חופת",
  "item.minecraft.map": "הקיר הפמ",
  "item.minecraft.golden_carrot": "בהזומ רזג",
  "block.minecraft.skeleton_skull": "דלש תלוגלוג",
  "block.minecraft.wither_skeleton_skull": "ר'תיוו דלש תלוגלוג",
  "block.minecraft.player_head": "ןקחש שאר",
  "block.minecraft.zombie_head": "יבמוז שאר",
  "block.minecraft.creeper_head": "רפירק שאר",
  "block.minecraft.dragon_head": "ןוקרד שאר",
  "item.minecraft.carrot_on_a_stick": "לקמ לע רזג",
  "item.minecraft.warped_fungus_on_a_stick": "לקמ לע תתוועמ הירטפ",
  "item.minecraft.nether_star": "ר'תנ בכוכ",
  "item.minecraft.pumpkin_pie": "תעלד יאפ",
  "item.minecraft.firework_rocket": "קוקיז ליט",
  "item.minecraft.firework_star": "קוקיז בכוכ",
  "item.minecraft.enchanted_book": "ףשוכמ רפס",
  "item.minecraft.nether_brick": "ר'תנ תנבל",
  "item.minecraft.quartz": "ץרווק ר'תנ",
  "item.minecraft.tnt_minecart": "ץפנ רמוח םע תינורק",
  "item.minecraft.hopper_minecart": "ךפשמ םע תינורק",
  "item.minecraft.prismarine_shard": "ןירמזירפ רבש",
  "item.minecraft.prismarine_crystals": "ןירמזירפ ילטסירק",
  "item.minecraft.rabbit": "אנ בנרא",
  "item.minecraft.cooked_rabbit": "לשובמ בנרא",
  "item.minecraft.rabbit_stew": "בנרא לישבת",
  "item.minecraft.rabbit_foot": "בנרא לגר",
  "item.minecraft.rabbit_hide": "בנרא רוע",
  "item.minecraft.armor_stand": "ןוירש דמעמ",
  "item.minecraft.iron_horse_armor": "לזרבמ סוס ןוירש",
  "item.minecraft.golden_horse_armor": "בהזמ סוס ןוירש",
  "item.minecraft.diamond_horse_armor": "םולהימ סוס ןוירש",
  "item.minecraft.leather_horse_armor": "רועמ סוס ןוירש",
  "item.minecraft.lead": "לבח",
  "item.minecraft.name_tag": "םש גת",
  "item.minecraft.command_block_minecart": "הדוקפ קולב םע תינורק",
  "item.minecraft.mutton": "אנ שבכ רשב",
  "item.minecraft.cooked_mutton": "לשובמ שבכ רשב",
  "block.minecraft.white_banner": "ןבל רנאב",
  "block.minecraft.orange_banner": "םותכ רנאב",
  "block.minecraft.magenta_banner": "הטנ'גמ רנאב",
  "block.minecraft.light_blue_banner": "תלכת רנאב",
  "block.minecraft.yellow_banner": "בוהצ רנאב",
  "block.minecraft.lime_banner": "םייל רנאב",
  "block.minecraft.pink_banner": "דורו רנאב",
  "block.minecraft.gray_banner": "רופא רנאב",
  "block.minecraft.light_gray_banner": "ריהב רופא רנאב",
  "block.minecraft.cyan_banner": "ןאיצ רנאב",
  "block.minecraft.purple_banner": "לוגס רנאב",
  "block.minecraft.blue_banner": "לוחכ רנאב",
  "block.minecraft.brown_banner": "םוח רנאב",
  "block.minecraft.green_banner": "קורי רנאב",
  "block.minecraft.red_banner": "םודא רנאב",
  "block.minecraft.black_banner": "רוחש רנאב",
  "item.minecraft.end_crystal": "דנא לטסירק",
  "item.minecraft.chorus_fruit": "סורוק ירפ",
  "item.minecraft.popped_chorus_fruit": "ץפונמ סורוק ירפ",
  "item.minecraft.beetroot": "םודא קלס",
  "item.minecraft.beetroot_seeds": "קלס יערז",
  "item.minecraft.beetroot_soup": "םודא קלס קרמ",
  "item.minecraft.dragon_breath": "ןוקרד תמישנ",
  "item.minecraft.splash_potion": "הנכהל ןתינ יתלב הזתה יוקיש□העפשה רסח",
  "item.minecraft.spectral_arrow": "רהוז ץח",
  "item.minecraft.tipped_arrow": "הנכהל ןתינ אל לובט ץח□העפשה רסח",
  "item.minecraft.lingering_potion": "הנכהל ןתינ יתלב תוהתשה יוקיש□העפשה רסח",
  "item.minecraft.shield": "ןגמ",
  "item.minecraft.elytra": "הרטילא",
  "item.minecraft.spruce_boat": "תיחושא תריס",
  "item.minecraft.birch_boat": "רדש תריס",
  "item.minecraft.jungle_boat": "לגנו'ג ץע תריס",
  "item.minecraft.acacia_boat": "הטיש תריס",
  "item.minecraft.dark_oak_boat": "ההכ ןולא תריס",
  "item.minecraft.totem_of_undying": "תוומלאה םטוט",
  "item.minecraft.shulker_shell": "רקלוש תייכנוק",
  "item.minecraft.iron_nugget": "לזרב שוג",
  "item.minecraft.knowledge_book": "עדיה רפס",
  "item.minecraft.debug_stick": "םיבצמה לקמ",
  "item.minecraft.music_disc_13": "הקיזומ קסיד□c418 - 13",
  "item.minecraft.music_disc_cat": "הקיזומ קסיד□c418 - cat",
  "item.minecraft.music_disc_blocks": "הקיזומ קסיד□c418 - blocks",
  "item.minecraft.music_disc_chirp": "הקיזומ קסיד□c418 - chirp",
  "item.minecraft.music_disc_far": "הקיזומ קסיד□c418 - far",
  "item.minecraft.music_disc_mall": "הקיזומ קסיד□c418 - mall",
  "item.minecraft.music_disc_mellohi": "הקיזומ קסיד□c418 - mellohi",
  "item.minecraft.music_disc_stal": "הקיזומ קסיד□c418 - stal",
  "item.minecraft.music_disc_strad": "הקיזומ קסיד□c418 - strad",
  "item.minecraft.music_disc_ward": "הקיזומ קסיד□c418 - ward",
  "item.minecraft.music_disc_11": "הקיזומ קסיד□c418 - 11",
  "item.minecraft.music_disc_wait": "הקיזומ קסיד□c418 - wait",
  "item.minecraft.music_disc_pigstep": "הקיזומ קסיד□pigstep - ןייר הניל",
  "item.minecraft.trident": "ןושלק□□:תישארה דיב רשאכ□הפיקת חוכ 8+□הפיקת תוריהמ 2.9-",
  "item.minecraft.phantom_membrane": "םוטנאפ םורק",
  "item.minecraft.nautilus_shell": "ןטייש תייכנוק",
  "item.minecraft.heart_of_the_sea": "םיה לש בלה",
  "item.minecraft.crossbow": "תבלצומ תשק",
  "item.minecraft.suspicious_stew": "ירותסמ לישבת",
  "block.minecraft.loom": "לונ",
  "item.minecraft.flower_banner_pattern": "לגד תינבת□חרפ ןעטמ",
  "item.minecraft.creeper_banner_pattern": "לגד תינבת□רפירק ןעטמ",
  "item.minecraft.skull_banner_pattern": "לגד תינבת□תלוגלוג ןעטמ",
  "item.minecraft.mojang_banner_pattern": "לגד תינבת□למס",
  "item.minecraft.globe_banner_pattern": "לגד תינבת□סובולג",
  "item.minecraft.piglin_banner_pattern": "לגד תינבת□םטוח",
  "block.minecraft.composter": "ןשדמ",
  "block.minecraft.barrel": "תיבח",
  "block.minecraft.smoker": "ןשעמ",
  "block.minecraft.blast_furnace": "ןשבכ",
  "block.minecraft.cartography_table": "יופימ ןחלוש",
  "block.minecraft.fletching_table": "םיציח תנכה ןחלוש",
  "block.minecraft.grindstone": "תזחשמ ןבא",
  "block.minecraft.lectern": "םירפס דמעמ",
  "block.minecraft.smithing_table": "תוחפנ ןחלוש",
  "block.minecraft.stonecutter": "םינבא ךתוח",
  "block.minecraft.bell": "ןומעפ",
  "block.minecraft.lantern": "תיששע",
  "block.minecraft.soul_lantern": "המשנ תרונמ",
  "item.minecraft.sweet_berries": "םיקותמ רעי תוריפ",
  "block.minecraft.campfire": "הרודמ",
  "block.minecraft.soul_campfire": "תומשנ תרודמ",
  "block.minecraft.shroomlight": "רהוז תיירטפ",
  "item.minecraft.honeycomb": "שבד תלח",
  "block.minecraft.bee_nest": "םירובד ןק",
  "block.minecraft.beehive": "תרווכ",
  "item.minecraft.honey_bottle": "שבד קובקב",
  "block.minecraft.honey_block": "שבד קולב",
  "block.minecraft.honeycomb_block": "שבד תלח קולב",
  "block.minecraft.lodestone": "טיטנגמ",
  "block.minecraft.netherite_block": "טייר'תנ קולב",
  "block.minecraft.ancient_debris": "םיקיתע םיסיסר",
  "block.minecraft.target": "הרטמ",
  "block.minecraft.crying_obsidian": "הכוב ןאידיסבוא",
  "block.minecraft.blackstone": "הרוחש ןבא",
  "block.minecraft.blackstone_slab": "היוצח הרוחש ןבא",
  "block.minecraft.blackstone_stairs": "הרוחש ןבא תוגרדמ",
  "block.minecraft.gilded_blackstone": "תבהזומ הרוחש ןבא",
  "block.minecraft.polished_blackstone": "תשטולמ הרוחש ןבא",
  "block.minecraft.polished_blackstone_slab": "היוצח תשטולמ הרוחש ןבא",
  "block.minecraft.polished_blackstone_stairs": "תשטולמ הרוחש ןבא תוגרדמ",
  "block.minecraft.chiseled_polished_blackstone": "תלסופמ תשטולמ הרוחש ןבא",
  "block.minecraft.polished_blackstone_bricks": "תשטולמ הרוחש ןבא ינבל",
  "block.minecraft.polished_blackstone_brick_slab": "תויוצח תשטולמ הרוחש ןבא ינבל",
  "block.minecraft.polished_blackstone_brick_stairs": "תשטולמ הרוחש ןבא ינבל תוגרדמ",
  "block.minecraft.cracked_polished_blackstone_bricks": "הקודס תשטולמ הרוחש ןבא ינבל",
  "block.minecraft.respawn_anchor": "תושדחתה ןגוע",
}
export const he_il = items; 
